import { ApiClient } from "recombee-js-api-client";

const recombeeDB: string = import.meta.env.REACT_APP_RECOMBEE_DB || "";
const recombeePublicKey: string = import.meta.env.REACT_APP_RECOMBEE_PUBLIC_KEY || "";

export const recombeeClient = new ApiClient(recombeeDB, recombeePublicKey);
